import Vue from 'vue';
import Viewer from 'v-viewer';
import JsonExcel from 'vue-json-excel';
// eslint-disable-next-line import/order
import App from './App.vue';
import ViewUI from 'view-design';
import 'view-design/dist/styles/iview.css';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import SourceMixin from '@/mixins/source';

// eslint-disable-next-line import/extensions
import SystemSelect from '@/components/system-select';
// eslint-disable-next-line import/extensions
import ColumnSwitch from '@/components/column-switch';
import './assets/index';
import VueClipboard from 'vue-clipboard2';
import axios from 'axios';
import { getToken } from '@/utils/request';
import commonPlugin from '@/common';
import router from './router';
import store from './store';
import * as filters from './filters';
import 'viewerjs/dist/viewer.css';
import '@/styles/icon.scss';

axios.defaults.headers['paas-token'] = getToken();
axios.defaults.headers['req-agent'] = 'apm';
// 引入基本模板
const echarts = require('echarts/lib/echarts');
// 引入柱状图组件
require('echarts/lib/chart/bar');
require('echarts/lib/chart/line');
require('echarts/lib/chart/pie');
require('echarts/lib/chart/gauge');

// 引入提示框和title组件
// require('echarts/lib/component/toolbox');
// require('echarts/lib/component/grid');
require('echarts/lib/component/tooltip');
require('echarts/lib/component/title');
require('echarts/lib/component/legend');

Vue.mixin(SourceMixin);
Vue.prototype.$echarts = echarts;
Vue.config.productionTip = false;
Vue.use(ElementUI);
Vue.use(ViewUI);
Vue.component('system-select', SystemSelect);
Vue.component('column-switch', ColumnSwitch);
Vue.component('downloadExcel', JsonExcel);

// register global filters.
Object.keys(filters).forEach((key) => {
  Vue.filter(key, (filters)[key]);
});

ViewUI.LoadingBar.config({
  color: '#5cb85c',
  failedColor: '#f0ad4e',
  height: 3,
});

Vue.use(Viewer, {
  defaultOptions: {
    zIndex: 99999,
  },
});
Vue.use(VueClipboard);
Vue.use(commonPlugin);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
